import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserStore } from '../services/current-user-store';

/**
 * Route guard factory that passes if the signed-in user holds <em>any</em> of the
 * supplied permissions. Chaining two <code>permissionGuard</code> calls would
 * AND them together (CanActivate semantics), which isn't what we want for
 * endpoints reachable by either of two permissions (e.g. customer edit is open
 * to ManageCustomers holders OR EditOwnCustomer holders).
 */
export const anyPermissionGuard = (permissionKeys: string[]): CanActivateFn => async () => {
  const store = inject(CurrentUserStore);
  const router = inject(Router);

  if (store.me() === null) {
    await store.load();
  }

  const held = store.permissions();
  if (permissionKeys.some((k) => held.includes(k))) return true;
  return router.createUrlTree(['/dashboard']);
};
